<template>
  <UppyUploaderWrapper
    :uppyId="uppyId"
    :metadata="metadata"
    :height="height"
    :document-type-id="documentTypeId"
    :upload-success="uploadSuccess"
    :upload-complete="uploadComplete"
    :contact-us="contactUs"
    @errorMessageUpdate="setErrorMessage"
    @uploadComplete="handleUploadComplete"
  >
    <div class="file-upload">
      <div v-if="uploadedFiles?.length <= 0" class="drag-drop-area" :id="uppyId"></div>
      <div v-else v-show="uploadedFiles && uploadedFiles?.length > 0" class="uploaded-files">
        <div class="uploaded-file" v-for="(file, index) in uploadedFiles" :key="index">
          {{ file }}
          <ul>
            <li class="file">
              <div class="filename">
                <div class="column-left">
                  <font-awesome-icon class="icon complete" :icon="['fas', 'circle-check']" />
                </div>
                <div class="column-right">
                  <p>{{ file?.name }}</p>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </UppyUploaderWrapper>
</template>

<script setup lang="ts">
import { ref, defineProps, computed, defineEmits, reactive } from "vue";
import { useStore } from "vuex";
import UppyUploaderWrapper from "@/components/shared/UppyUploaderWrapper.vue";
import { DocumentEntityTypes } from "@/models/enums";

const props = defineProps({
  applicationId: { type: Number },
  applicant: { type: Object },
  documentTypeId: { type: Number },
  height: { type: Number, default: 400 },
  name: { type: String },
  stipulationId: { type: Number, required: false },
  uploadSuccess: { type: Boolean, required: false },
  uploadComplete: { type: Boolean, required: false },
});

const emit = defineEmits(["getDocuments", "uploadSuccess", "errorMessageUpdated"]);
const store = useStore();

let uploadedFiles = reactive([] as any[]);

const fileUploadComplete = ref<boolean>(false);
const errorMessageText = ref<string>("");

const uppyId = computed<string>(() => `uppy_${props?.name}`);
const oidcUser = computed(() => store.getters["oidcStore/oidcUser"]);
const contactUs = computed(() => store.getters["contactUs"]);

const metadata = computed(() => store.getters["checklistModule/getUploadMetadata"](props.stipulationId, oidcUser?.value?.sub));

function setErrorMessage(event: any) {
  errorMessageText.value = event.errorMessage;
}

function handleUploadComplete(event: any) {
  const file = event?.successful[0];
  if (file) {
    emit("uploadSuccess", { result: true });
    uploadedFiles = event.successful;
    fileUploadComplete.value = true;
  }
}
</script>

<style lang="scss" scoped>
.uploaded-files {
  p {
    margin-bottom: 0;
  }

  .icon {
    &.complete {
      color: green;
    }
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    li {
      color: green;
    }
  }
  .filetype,
  .filename {
    display: flex;
    font-weight: normal;
    font-size: 1rem;
    .column-left {
      width: 5%;
    }
    .column-right {
      width: 95%;
    }
  }
}
</style>
